export default __webpack_public_path__ + "assets/images/win_icon.png";